import { MatTooltipDefaultOptions } from "@angular/material/tooltip";

export const customTooltipOptions: Partial<MatTooltipDefaultOptions> = {
    showDelay: 350,
    hideDelay: 100,
};